import { useAccordionButton, AccordionContext } from "react-bootstrap";
import { useContext } from "react";
import { ChevronDown } from "react-bootstrap-icons";
import { accordionBtnStyle, BtnClsNames } from "../config/btn_config";
//created to override the default behavior of the accordion header btn
export const ToggleHeader = ({ eventKey, children }) => {
    const onToggle = useAccordionButton(eventKey);
    const { activeEventKey } = useContext(AccordionContext);
    const open = activeEventKey === eventKey;

    return (
        <div
            role="button"
            onClick={onToggle}
            className={BtnClsNames}
            style={{
                ...accordionBtnStyle,
                width: "100%",
                padding: "12px 16px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 8,
                cursor: "pointer",
            }}
        >
            {children}
            <ChevronDown
                className="ms-auto"
                style={{
                    transform: open ? "rotate(180deg)" : "none",
                    transition: "transform .2s",
                }}
            />
        </div>
    );
};
